import React from "react";
import Link from "@helpers/link";

const ProductGrid = ({ items, productRefs, onClick }) => {
    if (!items) return null;

    return (
        <div className="product-grid">
            <div className="product-grid__inner">
                {items.map((item, index) => (
                    <div
                        key={item?.id}
                        className="product-grid__item"
                        data-category-id={item?.category?.id}
                        /* eslint-disable no-param-reassign */
                        ref={(element) => {
                            if (productRefs?.current) {
                                productRefs.current[index] = element;
                            }
                            return null;
                        }}
                        /* eslint-enable no-param-reassign */
                    >
                        <Link to={item?.url} onClick={(e) => onClick(e, item)}>
                            <div className="product-grid__item-wrapper">
                                <div className="product-grid__item-image-wrapper">
                                    <div className="product-grid__item-image-ratio">
                                        {item?.image ? <img className="product-grid__item-image" src={item?.image} alt={item?.alt} /> : ''}
                                        <div className="product-grid__item-details">
                                            <div className="product-grid__item-details-url">
                                                Details
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="product-grid__item-content">
                                    <div className="product-grid__item-title">
                                        {item?.title && (
                                            <>
                                                <div className="product-grid__item-title-name">{item.title.split(" - ")[0]}</div>
                                                {item.title.split(" - ")[1] && (<div className="product-grid__item-title-model">{item.title.split(" - ")[1]}</div>)}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default ProductGrid;
